var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4316 34.3125H16.9916C16.1636 34.3125 15.4916 33.6405 15.4916 32.8125C15.4916 31.9845 16.1636 31.3125 16.9916 31.3125H31.4316C32.2596 31.3125 32.9316 31.9845 32.9316 32.8125C32.9316 33.6405 32.2596 34.3125 31.4316 34.3125Z",
    fill: "#3940A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4316 25.9399H16.9916C16.1636 25.9399 15.4916 25.2679 15.4916 24.4399C15.4916 23.6119 16.1636 22.9399 16.9916 22.9399H31.4316C32.2596 22.9399 32.9316 23.6119 32.9316 24.4399C32.9316 25.2679 32.2596 25.9399 31.4316 25.9399Z",
    fill: "#3940A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.501 17.5859H16.991C16.163 17.5859 15.491 16.9139 15.491 16.0859C15.491 15.2579 16.163 14.5859 16.991 14.5859H22.501C23.329 14.5859 24.001 15.2579 24.001 16.0859C24.001 16.9139 23.329 17.5859 22.501 17.5859Z",
    fill: "#3940A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_456_412",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 37,
    height: 41
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.36572H42.3294V44.1853H6V4.36572Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_456_412)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8174 7.36523L16.4394 7.37323C11.7834 7.40123 8.99939 10.2812 8.99939 15.0792V33.4712C8.99939 38.3012 11.8094 41.1852 16.5114 41.1852L31.8894 41.1792C36.5454 41.1512 39.3294 38.2672 39.3294 33.4712V15.0792C39.3294 10.2492 36.5214 7.36523 31.8174 7.36523ZM16.5134 44.1852C10.2254 44.1852 5.99939 39.8792 5.99939 33.4712V15.0792C5.99939 8.61323 10.0934 4.41123 16.4294 4.37323L31.8154 4.36523H31.8174C38.1054 4.36523 42.3294 8.67123 42.3294 15.0792V33.4712C42.3294 39.9352 38.2354 44.1392 31.8994 44.1792L16.5134 44.1852Z",
    fill: "#3940A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentBlue);
export default __webpack_public_path__ + "static/media/DocumentBlue.44afddca61a3f62e425b9dd3e4669a39.svg";
export { ForwardRef as ReactComponent };